import {Component, NgZone} from '@angular/core';
import {AlertController, Events, IonicPage, NavController, NavParams} from 'ionic-angular';
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {CourseVideo} from "../../models/course-video";
import {AppVideoDetailsPage} from "../app-video-details/app-video-details";
import {AppVideoPlayerPage} from "../app-video-player/app-video-player";
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import * as moment from "moment";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppVideoPlusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-video-plus',
  templateUrl: 'app-video-plus.html',
})
export class AppVideoPlusPage {
  public moduleVideoDetailsPage: any = AppVideoPlayerPage
  public userClosed: number = 0;
  public additionalVideos: Array<CourseVideo>;
  public moduleWatchedVideos: number = 0;
  public watchedPlusVideos: number = 0;
  public modulePosition: number = null;
  public nextLockedVideo: any;


  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public apiCourseData: ApiCourseDataProvider,
      public events: Events,
      public userStats: UserStatsProvider,
      public userState: UserStateProvider,
      public ngZone: NgZone,
      public progressProvider: UserProgressStateProvider,
      public alertCtrl: AlertController,
      public contentTranslation: ContentTranslationProvider
  ) {
    var me = this;
    this.apiCourseData.getCourseData().then(courseData => {
      this.additionalVideos = this.apiCourseData.getAddtionalVideos().sort((a, b) => {
        return a.position > b.position ? 1 : -1;
      });

      this.additionalVideos.map(row => {
        if(row._userStatus == 3) {
          me.userClosed++;
        }
        if(row._userStatus == -1 && row.bonusVideo && !this.nextLockedVideo) {
          this.nextLockedVideo = row;
        }
      });
      this.watchedPlusVideos = this.additionalVideos.filter(v => {
        return !v.bonusVideo;
      }).length;

    });

    let calculateNextVideoProgress = () => {
      let currentProgress = this.progressProvider.currentProgress;
      if(currentProgress && currentProgress.video && currentProgress.video.module) {
        this.modulePosition = currentProgress.video.module.position;
        this.moduleWatchedVideos = currentProgress.video.position;
        if (currentProgress.isFinished()) {
          this.moduleWatchedVideos++;
        }
      }
    };
    calculateNextVideoProgress();

    this.events.subscribe('' +
      '', () => {
      calculateNextVideoProgress();

      this.apiCourseData.getCourseData().then(courseData => {
        this.additionalVideos = this.apiCourseData.getAddtionalVideos().sort((a, b) => {
          return a.position > b.position ? 1 : -1;
        });

        this.additionalVideos.map(row => {
          if (row._userStatus == 3) {
            me.userClosed++;
          }
        })

        this.watchedPlusVideos = this.additionalVideos.filter(v => {
          return !v.bonusVideo;
        }).length;
      })
    });
  }

  goBack() {
    this.navCtrl.parent.select(0);
  }


  ionViewDidEnter() {
    console.log('ionViewDidEnter AppVideoPlusPage');
    this.userClosed = 0;
    this.additionalVideos.map(row => {
      if(row._userStatus == 3) {
        this.userClosed++;
      }
    });

  }

  openVideo(video) {
    if(!this.userState.user.started && !video.bonusVideo) {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Noch nicht freigeschaltet!'),
        subTitle: this.contentTranslation.translateContent('Die Rubrik Video+ ist nicht Teil des Schnupperkurses. Um diese Zusatzvideos mit Ivonne freizuschalten, musst Du die Probewoche beenden und den Registrierungsvorgang abschließen. Dann werden automatisch alle Zusatzvideos freigschaltet.'),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();

      return ;
    }
    this.navCtrl.push(AppVideoPlayerPage, video);
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-video-plus/app-video-plus.ts